<template>
<div>
    <div class="table-wrapper on-767" v-if="$i18n.locale=='en'" >
        <div class="custom-table governance directors-meeting" data-aos="fade-up">
            <div class="table-heading">Board Audit Committee Meetings:</div>
            <div class="trow head border-0 bg-green">
                <div class="th ">NAME </div>
                <div class="th text-center">MEETING no. 1/2020<br> 11/2/2020</div>
                <div class="th text-center">MEETING No. 2/2020<br>14/7/2020</div>
                <div class="th text-center">MEETING No. 3/2020<br>2/11/2020</div>
            </div>
            <div class="trow">
                <div><strong>Nasser bin Suleiman Al-Harthy</strong><br>(Committee Chairman)</div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>Aladdin Baitfadhil</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>Abdulrahman Mohammad Ibrahim Al Asfour</strong><br >Independent</div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>Yousef Khaled Al-Abdulrazzaq</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="table-heading b-top-0">Previous Members</div>
            <div class="trow">
                <div><strong>Martial Caratti</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>Nigel Covett</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>Abdullah Al Harthy</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            </div>
            <div class="trow grey percentage">
                <div><strong>Percentage of Members in Attendance</strong></div>
                <div class="text-center"><strong>100%</strong></div>
                <div class="text-center"><strong>100%</strong></div>
                <div class="text-center"><strong>100%</strong></div>
            </div>
        </div>
        </div>

     <div class="table-wrapper on-767" v-if="$i18n.locale=='ar'" >
        <div class="custom-table governance directors-meeting" data-aos="fade-up">
            <div class="table-heading">اجتماعات لجنة التدقيق</div>
            <div class="trow head border-0 bg-green">
                <div class="th ">اسم العضو</div>
                <div class="th text-center">اجتماع رقم 2020/1<br> 11/2/2020</div>
                <div class="th text-center">اجتماع رقم 2020/2<br>2020/7/14</div>
                <div class="th text-center">اجتماع رقم 2020/3<br>2020/11/2</div>
            </div>
            <div class="trow">
                <div><strong>ناصر بن سليمان الحارثي<br>(رئيس اللجنة)</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>علاء الدين بيت فاضل</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>عبد الرحمن محمد العصفور<br >(عضو مستقل)</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>يوسف خالد العبدالرزاق</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
            </div>
            <div class="table-heading b-top-0">أعضاء سابقون</div>
            <div class="trow">
                <div><strong>مارتيال كاراتي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>نيجيل كوفيت</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            </div>
            <div class="trow">
                <div><strong>عبدالله الحارثي</strong></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/tik.svg" alt=""></div>
                <div class="text-center"><img src="@/assets/images/svg/minus.svg" alt=""></div>
            </div>
            <div class="trow grey percentage">
                <div><strong>نسبة الحضور</strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
                <div class="text-center"><strong>100<span class="ltr">%</span></strong></div>
            </div>
        </div>
        </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>